import { Col, Popconfirm, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
// import * as Icon from "react-icons/all";
import { FaSearch } from "react-icons/fa";
import { CiCircleRemove } from "react-icons/ci";
import moment from "moment";
import React, { useEffect, useState } from "react";

import { Colors, Fonts, Images } from "../../config";
import {
  Modal,
  Pagination,
  Switch,
  Table,
  Text,
  TextField,
} from "../../components";

import {
  MontserratBold,
  MontserratLight,
  MontserratRegular,
} from "../../config/fonts";
import { ArtistAction } from "../../store/actions";
import Basic from "../../components/Modal/Basic";
import EditArtist from "./ArtistEmail";
import ArtistEmail from "./ArtistEmail";

function ArtistManagement() {
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = useState(null);
  const artists = useSelector((state) => state.artist);
  const [page, setPage] = useState(1);
  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    keyword: "",
    status: "",
    role_name: "artist",
  });
  const [isOpen, setIsOpen] = useState(false);

  const handlePagination = (pageNumber) => {
    let offset = (pageNumber - 1) * state.limit;
    setState({ ...state, offset: offset });
    setPage(pageNumber);
  };

  const handleChangeStatus = (id) => {
    dispatch(
      ArtistAction.changeArtistStatus(id, () => {
        dispatch(ArtistAction.getArtistListing(state));
        setPage(1);
      })
    );
  };

  const handleDeleteArtist = (id) => {
    dispatch(
      ArtistAction.deleteArtist(id, () => {
        dispatch(ArtistAction.getArtistListing(state));
      })
    );
  };

  useEffect(() => {
    dispatch(ArtistAction.getArtistListing(state));
  }, [page, state]);

  const handleOpen = (data) => {
    setIsOpen(true);
    setSelectedData(data);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleApproveArtist = (id) => {
    dispatch(
      ArtistAction.approveArtist({ id, status: true }, () => {
        dispatch(ArtistAction.getArtistListing(state));
        setPage(1);
      })
    );
  };

  const handleRejectArtist = (id) => {
    dispatch(
      ArtistAction.approveArtist({ id, status: false }, () => {
        dispatch(ArtistAction.getArtistListing(state));
        setPage(1);
      })
    );
  };

  return (
    <>
      <div className="wrapper">
        <Row className="flex-row-space-center mb-5 mx-15">
          <Col className="flex-column" span={9}>
            <div className="flex-row-align-center">
              <Text.Basic
                text="Artists"
                color={Colors.Black}
                fontSize={25}
                fontWeight={600}
                fontFamily={Fonts[MontserratBold]}
                textAlign="left"
              />
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  background: "#7836FF",
                  borderRadius: "50px",
                  marginInline: "10px",
                }}
              ></span>
              <Text.Basic
                text={artists?.count}
                color={Colors.Black}
                fontSize={18}
                fontWeight={400}
                fontFamily={Fonts[MontserratRegular]}
                textAlign="left"
              />
            </div>
            {/* <Text.Basic
            text={`Deleted artists: ${users?.deleted}`}
            color={Colors.LightGray}
            fontSize={16}
            fontWeight={300}
            fontFamily={Fonts[MontserratLight]}
            textAlign="left"
          />
          <Text.Basic
            text={`These are the users currently registered in the app`}
            color={Colors.LightGray}
            fontSize={14}
            fontWeight={300}
            fontFamily={Fonts[MontserratLight]}
            textAlign="left"
            className="mt-10"
          /> */}
          </Col>
          <Col span={15}>
            <Row gutter={[25, 25]} className="flex-row-end">
              <Col span={9}>
                <TextField.IconField
                  className="listing-filter"
                  size={"large"}
                  suffix={<FaSearch />}
                  placeholder={"Search Artists"}
                  value={state.keyword}
                  onChange={(e) =>
                    setState({
                      ...state,
                      keyword: e.target.value,
                    })
                  }
                />
              </Col>
              {/* <Col span={9} className="user-location-search">
                <TextField.Autocomplete
                    inputStyle={{ width: "100%" }}
                    suffixIcon={<Icon.FaSearch size={16} color="black" />}
                    size={"large"}
                    onClear={handleClearLocation}
                    notFoundContent={"No location found"}
                    value={location ? location : undefined}
                    placeholder={"Search by location"}
                    onSearch={handleSearchLocation}
                    onSelect={handleSelectLocation}
                    options={users?.locations}
                />
                </Col> */}
              <Col span={6}>
                <TextField.SelectField
                  inputStyle={{ width: "100%" }}
                  className="listing-filter"
                  size={"large"}
                  allowClear={false}
                  onChange={(value) => {
                    if (value === "all") {
                      setState({
                        ...state,
                        status: "",
                      });
                    } else {
                      setState({
                        ...state,
                        status: value,
                      });
                    }
                  }}
                  value={state.status === "" ? "all" : state.status}
                  options={[
                    {
                      label: "View All",
                      value: "all",
                    },
                    {
                      label: "Active",
                      value: "active",
                    },
                    {
                      label: "Suspended",
                      value: "suspended",
                    },
                    {
                      label: "Rejected",
                      value: "rejected",
                    },
                    {
                      label: "Deactivated",
                      value: "deactivated",
                    },
                    {
                      label: "Unapproved",
                      value: "unapproved",
                    },
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Table.Basic
          columns={[
            {
              title: "Sno",
              dataIndex: "sno",
              key: "sno",
              render: (text, record, i) => (
                <span
                  className="ml-10 table-cell"
                  title={state.offset + (i + 1)}
                >
                  {state.offset + (i + 1)}
                </span>
              ),
            },
            {
              title: "Name",
              dataIndex: "name",
              key: "name",
              render: (text, record) => (
                <span className="ml-10 table-cell" title={text}>
                  {text.length > 15 ? `${text.slice(0, 15)}...` : text}
                </span>
              ),
            },
            {
              title: "Email",
              dataIndex: "email",
              key: "email",
              render: (text, record) => (
                <span className="table-cell" title={text}>
                  {text.length > 15 ? `${text.slice(0, 15)}...` : text}
                </span>
              ),
            },
            {
              title: "ID",
              dataIndex: "id",
              key: "id",
              render: (text, record) => (
                <span className="table-cell" title={text}>
                  {text.length > 15 ? `${text.slice(0, 15)}...` : text}
                </span>
              ),
            },
            {
              // title: "approve",
              dataIndex: "status",
              key: "status",
              render: (text, record) => (
                <div className="flex-row-align-center">
                  {record?.status == "unapproved" && (
                    <div className="flex-row-align-center">
                      <button
                        className="btn-simple cursor"
                        onClick={() => handleApproveArtist(record?.id)}
                      >
                        <img
                          width={25}
                          className="mx-15"
                          src={Images.CheckIcon}
                          alt=""
                        />
                      </button>
                      <button
                        className="btn-simple cursor"
                        onClick={() => handleRejectArtist(record?.id)}
                      >
                        <img width={25} src={Images.RemoveIcon} alt="" />
                      </button>
                    </div>
                  )}
                </div>
              ),
            },
            {
              title: "Status",
              dataIndex: "status",
              key: "status",
              render: (text, record) => (
                <div className="flex-row-align-center">
                  <span
                    className="table-cell"
                    style={{
                      color:
                        text === "active" ? Colors.BlueText : Colors.RedText,
                      backgroundColor:
                        text === "active" ? "#7836FF1A" : "#FF606B1A",
                      padding: "10px",
                      borderRadius: "10px",
                      textTransform: "capitalize",
                    }}
                  >
                    {text}
                  </span>
                </div>
              ),
            },
            {
              title: "Action",
              dataIndex: "",
              key: "",
              render: (text, record) => (
                <div className="flex-row-align-center">
                  <span
                    className="d-block mr-2"
                    onClick={() => handleOpen(record)}
                  >
                    <img
                      src={Images.EditIcon}
                      width={30}
                      className="cursor mr-2"
                    />
                  </span>

                  <span className="d-block mr-5">
                    <Popconfirm
                      title="Delete file"
                      description="Are you sure you want delete this user's record?"
                      onConfirm={() => handleDeleteArtist(record?.id)}
                      icon={<CiCircleRemove size={20} color="red" />}
                      placement="topRight"
                      okText="Yes"
                      cancelText="No, Keep it"
                    >
                      <img
                        src={Images.DeleteIcon}
                        width={28}
                        className="cursor"
                      />
                    </Popconfirm>
                  </span>

                  {(record?.status == "active" ||
                    record?.status == "suspended") && (
                    <span>
                      <Switch.Basic
                        checked={record.status !== "suspended" ? true : false}
                        onChange={(e) => handleChangeStatus(record?.id)}
                      />
                    </span>
                  )}
                </div>
              ),
            },
          ]}
          // data={users?.users}
          data={artists?.artists}
          loading={artists.isLoading}
          // loading={users.isLoading}
        />
        {artists.count > 10 && (
          <Row justify={"center"} className="mt-10">
            <Col>
              <Pagination.Basic
                onChange={handlePagination}
                pageSize={10}
                current={page}
                total={artists.count}
              />
            </Col>
          </Row>
        )}
      </div>

      <Modal.Basic
        className="modal-lg"
        centered={true}
        title=""
        closable={false}
        open={isOpen}
        handleCancel={handleCancel}
        children={<ArtistEmail data={selectedData} closeModal={handleCancel} />}
      />
    </>
  );
}

export default ArtistManagement;
